import { CustomInputComponent } from '../custom-input'
import * as $ from 'jquery'

const DEFAULT_OTHER_VALUE = 'other';

declare global {
  interface JQuery {
    iwOtherField(): JQuery;
  }
}

/**
 * A jQuery plugin can automatically hide and show a text field for a select input with an "other" option
 */
export class OtherFieldComponent extends CustomInputComponent {

  public static readonly COMPONENT_ATTR = 'iw-other-field';
  public static readonly COMPONENT_SELECTOR = `[${OtherFieldComponent.COMPONENT_ATTR}]`;
  public static readonly ATTR_OTHER_VALUE = `${OtherFieldComponent.COMPONENT_ATTR}-value`;

  public static loadPlugin(): void {
    super.loadPlugin();
    if (!$.fn.iwOtherField) {
      $.fn.iwOtherField = this.jQueryPlugin('OtherFieldComponent');
    }
  }

  public readonly $form: JQuery<HTMLFormElement>;
  public readonly $other: JQuery;
  public readonly otherValue: string;

  constructor($el: JQuery) {
    super($el);

    this.$form = this.$el.parents('form');
    this.$other = this.$form.find(this.$el.attr(OtherFieldComponent.COMPONENT_ATTR));
    this.otherValue = this.$el.attr(OtherFieldComponent.ATTR_OTHER_VALUE) || DEFAULT_OTHER_VALUE;

    this.initEvents();
    this.onSelectChange();
  }

  protected initEvents(): void {
    this.$el.on('change', this.onSelectChange.bind(this));
  }

  protected onSelectChange(): void {
    const show = (this.$el.val() as string).toLocaleLowerCase() === this.otherValue;
    this.$other.toggle(show);
    if (show) {
      this.$other.trigger('focus');
    } else {
      // trigger a change event so that the implementation can update validation state if needed
      this.$other.trigger('change');
    }
  }
}
